import React from 'react';
import { Row, Col, Space } from 'antd';
import ScoreTierLegendIndividual from '../scoreTierLegend/scoreTierLegendIndividual';
import ResumeBarChartIndividual from '../../graphics/resumeBarChartIndividual';
import IndividualRelTypeCount from '../individualRelTypeCount/individualRelTypeCount';

const IndividualSummary = ({ individualResult, redLight, yellowLight }) => {
    const dimensions = Object.entries(individualResult?.average_by_dimension || {})
        .filter(([key, _]) => !key.toLowerCase().includes("general"))
        .map(([_, value]) => value);
    

    const getColor = (value) => {
        if (value <= redLight) return "#e53935"; // rojo
        if (value <= yellowLight) return "#fbc02d"; // amarillo
        return "#43a047"; // verde
    };

    const getContrastTextColor = (bgColor) =>
        String(bgColor).toLowerCase() === '#fbc02d' ? '#000' : '#fff';

    const scoreBgColor = getColor(individualResult.average);
    const scoreTextColor = getContrastTextColor(scoreBgColor);

    return (
        <Space direction="vertical" size="large" style={{ width: '100%', rowGap: 0 }}>            
            <Row gutter={[16, 0]} align="stretch">
                <Col xs={24} md={6}>
                    <span style={{ color: '#339C98', fontWeight: 500, fontSize: 20 }}>
                        Resúmen
                    </span>
                </Col>
                <Col xs={24} md={12}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <ScoreTierLegendIndividual redLight={redLight} yellowLight={yellowLight} />
                    </div>
                </Col>
                <Col xs={24} md={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div
                        style={{
                            backgroundColor: scoreBgColor,
                            width: 120,
                            height: "100%",
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 12,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        }}
                    >
                        <span style={{ fontSize: 14, color: scoreTextColor }}>Puntaje</span>
                        <span style={{ fontSize: 24, fontWeight: "bold", color: scoreTextColor }}>{individualResult.average}</span>
                    </div>
                </Col>
            </Row>
            <br />
            <Row gutter={[16, 0]} align="stretch">
                <Col xs={24} md={24}>
                    <ResumeBarChartIndividual data={dimensions} redLight={redLight} yellowLight={yellowLight} />
                    <IndividualRelTypeCount relationshipsByType={individualResult.relationships_by_type} />
                </Col>
            </Row>
        </Space>
    );
};

export default IndividualSummary;
